// extracted by mini-css-extract-plugin
export default {"HomeLayout_container":"HomeLayout_HomeLayout_container__c9FH9","layout_background":"HomeLayout_layout_background__AvQgV"};